import {Imports, IRootStyle, ITextEdits} from "./base/editor.interfaces";



const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;


const SF = globalImports.SF || (globalImports.SF = {});

class CustomizerTextElement extends SF.Model.TextElement {

    public addedByUser!:boolean;
    public placeHolderTranslations?: { [key: string]: string };
    // tslint:disable-next-line:variable-name
    public preview_image: string = '';
    public tlf: string = '';
    public originalHeight!: number;
    public edited: boolean = false;
    public text: string = '';

    constructor(text: string, public rootStyle: IRootStyle = {} as any, public styles: any = {},
                public textEdits?: ITextEdits, edited?: boolean) {
        super(text, rootStyle, styles, textEdits);
        // lets keep the text empty if it has empty string but it's edited...
        if ((text && (!textEdits || textEdits.edited || !textEdits.canEdit)) || (text === '' && edited)) {
            this.text = text;
        } else if (textEdits && textEdits.placeHolderTranslations) {
            this.setText(textEdits);
        } else {
            this.text = SF.Model.DefaultText['large'];
        }
        this.styles = styles || {};
    }

    protected setText(textEdits: ITextEdits): void {
        this.text = textEdits.placeHolderTranslations ? textEdits.placeHolderTranslations[this.getCurrentLanguage()] : '';
    }

    protected getCurrentLanguage(): string {
        return SF.currentLanguage;
    }

    public clone(): CustomizerTextElement {
        const textElement = new CustomizerTextElement(this.text, this.rootStyle, this.styles);
        this._clone(textElement);
        textElement.edited = this.edited;
        textElement.editable = this.editable;
        if (this.placeHolderTranslations) {
            textElement.placeHolderTranslations = this.placeHolderTranslations;
        }
        return textElement;
    }
}

SF.Model.TextElement = CustomizerTextElement;